import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import {
    ReferenceArrayInput,
    AutocompleteArrayInput,
    useNotify,
    useDataProvider,
} from 'react-admin';

import { Permissions } from '@src/global/permissions';

const TagsInput = (props) => {
    const { resource } = props;
    const dataProvider = useDataProvider();
    const notify = useNotify();

    const handleCreate = useCallback((value) => {
        return dataProvider.create(
            'tags',
            {
                data: { name: value },
            },
        ).then(({ data }) => {
            return data;
        }).catch((error) => {
            let errorMsg = 'Name has already been taken';
            if (Permissions('tags', 'create') !== true) {
                errorMsg = 'You don\'t have permission to create tags';
            }

            notify(errorMsg, { type: 'error' });
            throw error;
        });
    }, [dataProvider, notify]);

    return (
        <ReferenceArrayInput
            fullWidth
            label="Tags"
            reference="tags"
            resource={resource}
            source="tags"
        >
            <AutocompleteArrayInput
                optionText="name"
                shouldRenderSuggestions={(val) => {
                    return val.trim().length > 2;
                }}
                noOptionsText="No tags found. Type at least 3 characters to search."
                onCreate={handleCreate}
            />
        </ReferenceArrayInput>
    );
};

TagsInput.propTypes = {
    resource: PropTypes.string.isRequired,
};

export default TagsInput;
